if (typeof window !== 'undefined') {
  require('./indexedDB_databases').default()
}
